import styled from "styled-components";

export const Section = styled.section `
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 370px;

  margin-top: 243px;

  @media (max-width: 768px) {
    margin-top: 0;
    place-self: center;
  }
`;


export const SuccessContainer = styled.div `
  color: #0ECB00;
  margin-top: 38px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 30px;

  display: flex;
  justify-content: center;
  flex-direction: row;

  p {
    color: #4D565C;
    font-size: 1.5625rem;
    margin-left: 13px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    height: 150px;
    width: 210px;
    border: none;
    margin-top: 0;
    margin-bottom: 40px;
    text-align: center;
    place-items: center;

    p {
        font-size: 1.125rem;
    }

    svg {
        font-size: 46px;
    }
  }
`;


export const ButtonContainer = styled.div `
  margin-top: 57.5px;
  max-width: 389.91px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  a {
    text-decoration: none;
  }

  button {
    width: 100%;
  }

  @media (max-width: 768px) {
    margin-top: 0;
    min-height: calc(100vh - 356px);
  }
`;


export const Header = styled.header `
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const CircleYellow = styled.div `
  border-radius: 100%;
  border: 5px solid ${({theme}) => theme.colors.darkYellow};
  color: ${({theme}) => theme.colors.darkYellow};
  margin-bottom: 23px;
  max-height: 60px;
  max-width: 60px;
  height: 60px;
  width: 60px;
  min-width: 60px;
  min-height: 60px;
  display: flex;
  place-content: center;
  place-items: center;

  svg {
    margin: auto;
  }
`;
